import { firstValueFrom } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Constants } from "@constants";
import { EnvioDTO, IEnvioAgrupadoDTO, IEnvioDTO, IPaginadoDTO, PaginadoDTO } from "@DTOS";
import { map } from "rxjs/operators";
import { EncuestaEstadoDTO, IEncuestaEstadoDTO } from "../DTOS/EncuestaEstado.DTO";

@Injectable({
    providedIn: "root"
})
export class EnviosServiceBackend {
    constructor(protected httpClient: HttpClient) { }

    public async getEnviosEngage(pagina: number, cantidad: number): Promise<PaginadoDTO<EnvioDTO>> {
        const response = await firstValueFrom(
            this.httpClient.get<IPaginadoDTO<IEnvioDTO>>(`${Constants.apiURL}/series/engage`, {
                params: {
                    page: `${pagina}`,
                    size: `${cantidad}`
                }
            })
        );

        const envios = response.results.map(envio => new EnvioDTO(envio));
        return new PaginadoDTO({ ...response, results: envios });
    }

    public async getEnvio(id: number): Promise<EnvioDTO> {
        const response = await firstValueFrom(this.httpClient.get<IEnvioDTO>(`${Constants.apiURL}/series/${id}`));

        return new EnvioDTO(response);
    }

    public async putEnvio(envio: EnvioDTO): Promise<EnvioDTO> {
        const response = await firstValueFrom(
            this.httpClient.put<IEnvioDTO>(
                `${Constants.apiURL}/series/${envio.id}`, envio.toJSON()
            )
        );

        return new EnvioDTO(response);
    }

    public async getEnviosCuestionario(id: number): Promise<EnvioDTO[]> {
        const envioAgrupado = await firstValueFrom(this.httpClient.get<IEnvioAgrupadoDTO>(`${Constants.apiURL}/combos/${id}/series`));
        const response: IEnvioDTO[] = envioAgrupado.series ?? [];

        return response.map(envio => new EnvioDTO(envio));
    }

    public async getEnvioGrupo(grupoId: number, envioId: number): Promise<EnvioDTO> {
        return await firstValueFrom(
            this.httpClient.get<IEnvioDTO>(
                `${Constants.apiURL}/campaigns/${grupoId}/series/${envioId}`
            ).pipe(
                map(response => new EnvioDTO(response))
            )
        );
    }

    public async putEnvioGrupo(envio: EnvioDTO): Promise<EnvioDTO> {
        return await firstValueFrom(
            this.httpClient.put<IEnvioDTO>(
                `${Constants.apiURL}/campaigns/${envio.grupoId}/series/${envio.id}`, envio.toJSON()
            ).pipe(
                map(response => new EnvioDTO(response))
            )
        );
    }

    public async getEncuestaEstado(grupoId: number, envioId: number, encuestaId: number): Promise<EncuestaEstadoDTO> {
        return await firstValueFrom(
            this.httpClient.get<IEncuestaEstadoDTO>(
                `${Constants.apiURL}/campaigns/${grupoId}/series/${envioId}/combos/${encuestaId}`
            ).pipe(
                map(response => new EncuestaEstadoDTO(response))
            )
        );
    }
}
